// =================================================================
// DecodexMenu.js - Menu DECODEX Intégré Sidebar Oracle TRYA
// Titre DECODEX sorti de la case rosée - Version corrigée
// =================================================================

import React, { useState } from 'react';
import { Play } from 'lucide-react';
import { toast } from '../ui/Toast';

const DecodexMenu = ({ onAnalyze, user }) => {
  const [formData, setFormData] = useState({
    prenom: '',
    nom: '',
    format: 'standard'
  });
  const [isAnalyzing, setIsAnalyzing] = useState(false);

  // 6 Analyseurs Pierre selon mockup final V2
  const analyzers = [
    { id: 'etymologique', label: 'Étymologique', icon: '📚' },
    { id: 'syllabique', label: 'Syllabique', icon: '🔤' },
    { id: 'numerologique', label: 'Numérologique', icon: '🔢' },
    { id: 'formatif', label: 'Formatif', icon: '⚡' },
    { id: 'anagrammatique', label: 'Anagrammatique', icon: '🔄' },
    { id: 'triangulation', label: 'Triangulation', icon: '🎯' }
  ];

  // Derniers décodages session (mock data)
  const recentDecodages = [
    { prenom: 'Annie', nom: 'Martin', date: '16:42' },
    { prenom: 'Pierre', nom: 'Dubois', date: '15:28' }
  ];

  const handleAnalyze = async () => {
    if (!formData.prenom.trim() || !formData.nom.trim()) {
      toast.warning('Veuillez renseigner le prénom et le nom');
      return;
    }

    setIsAnalyzing(true);
    try {
      await onAnalyze({
        prenom: formData.prenom,
        nom: formData.nom,
        format: formData.format,
        analyzers: analyzers
      });
    } catch (error) {
      console.error('Erreur analyse DECODEX:', error);
    } finally {
      setIsAnalyzing(false);
    }
  };

  return (
    <div className="decodex-container">
      <style>{`
        .decodex-container {
          margin: 16px 16px 20px 16px;
        }

        /* TITRE DECODEX EXTÉRIEUR - STYLE PROFESSIONNEL */
        .decodex-title {
          color: #475569;
          font-size: 13px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          padding: 10px 16px;
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
          border-radius: 10px;
          text-align: center;
          margin-bottom: 16px;
          border: 1px solid #cbd5e1;
        }

        .decodex-section {
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border-radius: 12px;
          padding: 16px;
          border: 1px solid #e2e8f0;
        }

        .analyzer-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px;
          margin-bottom: 16px;
        }

        .analyzer-btn {
          padding: 8px 6px;
          background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          font-size: 9px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease;
          color: #475569;
          font-weight: 500;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 2px;
        }

        .analyzer-btn:hover {
          background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
          border-color: #93c5fd;
          color: #1D4ED8;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(72, 136, 224, 0.15);
        }

        .decodex-form {
          margin-bottom: 15px;
        }

        .decodex-input {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 13px;
          background: #ffffff;
          color: #1e293b;
          margin-bottom: 8px;
          box-sizing: border-box;
          transition: all 0.2s ease;
        }

        .decodex-input:focus {
          outline: none;
          border-color: #94a3b8;
          box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.1);
        }

        .decodex-input::placeholder {
          color: #94a3b8;
        }

        .form-select {
          width: 100%;
          padding: 10px 12px;
          border: 1px solid #d1d5db;
          border-radius: 8px;
          font-size: 13px;
          background: #ffffff;
          color: #1e293b;
          margin-bottom: 16px;
          box-sizing: border-box;
        }

        .form-select:focus {
          outline: none;
          border-color: #94a3b8;
          box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.1);
        }

        .decodex-btn {
          width: 100%;
          padding: 12px 16px;
          background: linear-gradient(135deg, #1D4ED8 0%, #1e40af 100%);
          color: white;
          border: none;
          border-radius: 10px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          box-shadow: 0 4px 12px rgba(29,78,216,0.3), 0 0 8px rgba(29,78,216,0.15);
        }

        .decodex-btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 16px rgba(72, 136, 224, 0.3);
        }

        .decodex-btn:active {
          transform: translateY(0);
        }

        .decodex-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none;
        }

        .recent-decodages {
          margin-top: 20px;
          padding-top: 16px;
          border-top: 1px solid #e2e8f0;
        }

        .recent-title {
          font-size: 11px;
          color: #475569;
          font-weight: 600;
          margin-bottom: 12px;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }

        .decodage-item {
          padding: 8px 12px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border: 1px solid #e2e8f0;
          border-radius: 8px;
          margin-bottom: 6px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: all 0.2s ease;
        }

        .decodage-item:hover {
          background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
          border-color: #cbd5e1;
        }

        .decodage-name {
          color: #334155;
          font-weight: 500;
          font-size: 11px;
        }

        .decodage-time {
          color: #64748b;
          font-size: 10px;
          font-weight: 500;
        }

        .session-indicator {
          text-align: center;
          margin-top: 12px;
          font-size: 10px;
          color: #64748b;
          font-weight: 500;
          padding: 6px;
          background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
          border-radius: 6px;
          border: 1px solid #e2e8f0;
        }

        .loading-spinner {
          width: 12px;
          height: 12px;
          border: 2px solid rgba(255, 255, 255, 0.3);
          border-top: 2px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>

      {/* TITRE DECODEX SORTI DE LA CASE ROSÉE */}
      <div className="decodex-title">DECODEX</div>

      {/* CONTENU PRINCIPAL DANS LA CASE ROSÉE */}
      <div className="decodex-section">
        {/* Grille 6 Analyseurs - 2 colonnes pour 6 analyseurs (3 lignes) */}
        <div className="analyzer-grid">
          {analyzers.map((analyzer) => (
            <button
              key={analyzer.id}
              className="analyzer-btn"
              onClick={() => console.log(`Analyseur ${analyzer.label} sélectionné`)}
            >
              <span>{analyzer.icon}</span>
              <span>{analyzer.label}</span>
            </button>
          ))}
        </div>

        {/* Formulaire Décodage Rapide */}
        <div className="decodex-form">
          <input
            type="text"
            placeholder="Prénom"
            className="decodex-input"
            value={formData.prenom}
            onChange={(e) => setFormData(prev => ({ ...prev, prenom: e.target.value }))}
          />
          <input
            type="text"
            placeholder="Nom"
            className="decodex-input"
            value={formData.nom}
            onChange={(e) => setFormData(prev => ({ ...prev, nom: e.target.value }))}
          />

          <select
            className="form-select"
            value={formData.format}
            onChange={(e) => setFormData(prev => ({ ...prev, format: e.target.value }))}
          >
            <option value="standard">Standard</option>
            <option value="medium">Medium</option>
            <option value="premium">Premium</option>
            <option value="expert">Expert</option>
          </select>

          <button
            className="decodex-btn"
            onClick={handleAnalyze}
            disabled={isAnalyzing}
          >
            {isAnalyzing ? (
              <>
                <div className="loading-spinner"></div>
                <span>Analyse en cours...</span>
              </>
            ) : (
              <>
                <Play size={12} />
                <span>Lancer Analyse</span>
              </>
            )}
          </button>
        </div>

        {/* Sessions récentes */}
        <div className="recent-decodages">
          <div className="recent-title">Sessions récentes</div>
          {recentDecodages.map((decodage, index) => (
            <div key={index} className="decodage-item">
              <span className="decodage-name">{decodage.prenom} {decodage.nom}</span>
              <span className="decodage-time">{decodage.date}</span>
            </div>
          ))}
          <div style={{ fontSize: '10px', color: '#64748b', textAlign: 'center', marginTop: '12px', fontWeight: '500', padding: '6px', background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)', borderRadius: '6px', border: '1px solid #e2e8f0' }}>
            Par session courante
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecodexMenu;
